import { type PaginationType } from '@/types/pagination';

export const getNextPageParam = <T extends { pagination?: PaginationType | null }>(
  lastPage: T,
  limit: number | null,
): number | undefined => {
  const pagination = lastPage.pagination;

  if (!pagination) {
    return undefined;
  }

  const actualLimit = pagination.limit ?? limit ?? null;
  if (!actualLimit) {
    return undefined;
  }

  const offset = pagination.offset ?? 0;
  const total = pagination.count ?? 0;
  const nextOffset = offset + actualLimit;

  return nextOffset < total ? nextOffset : undefined;
};
